import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import MyNavigation from './Navigation';
import Main from './Main';
import CreateAccount from './pages/CreateAccount';
import CheckBalance from './pages/CheckBalance';
import StorageApp from './pages/StorageApp';
import Transfer from './pages/Transfer';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import reportWebVitals from './reportWebVitals';
import MarketPlace from './pages/MarketPlace';
import Token from './pages/Token';

function App() {
  return (
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MyNavigation />}>
            <Route index element={<Main />} />
            <Route path="CreateAccount" element={<CreateAccount />} />
            <Route path="CheckBalance" element={<CheckBalance />} />
            <Route path="Transfer" element={<Transfer />} />
            <Route path='StorageApp' element={<StorageApp />} />
            <Route path='MarketPlace' element={<MarketPlace />} />
            <Route path='Token' element={<Token />} />
          </Route>
        </Routes>
      </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
